// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Scrollbars from 'react-custom-scrollbars';

import '../../styles/modal.css';

export default class Tips extends React.Component {

    renderContent = () => (<></>);

    state = {
        stage: 0,
        visible: false
    }

    componentDidMount = () => {
        setTimeout(() => this.setState({
            stage: 0,
            visible: true
        }), 200);
    }

    nextStage = (e, stage) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.setState({ visible: false });
        setTimeout(() => this.setState({
            stage: stage ? stage : this.state.stage+1,
            visible: true
        }),500);
    }

    render = () => {
        return (<div
            className="modal-container"
            // onClick={() => this.props.modal()}
        >

            <img
                className="document-close"
                src="https://static.stax.ai/images/icons/close.png"
                alt="x"
                title="Close [Esc]"
                onClick={this.props.close}
            />

            <Scrollbars>
                <div className="tips-content" style={{ opacity: this.state.visible ? 1 : 0 }}>{this.renderContent()}</div>
            </Scrollbars>
            
        </div>);
    }

};